import { useDataTableQuery } from "@/components/data-table/hooks/useDataTableQuery";
import { useToast } from "@/components/ui/use-toast";
import { useMutationWithErrorHandling } from "@/hooks/useMutationWithErrorHandling";
import { useProjectId } from "@/modules/projects/hooks/useProjectId";
import { ProjectLimitService } from "@/modules/projects/service/projectLimit";
import { ApiError, SuccessFetchListResponse } from "@/services/api";
import { ReadProjectLimit } from "@/types/projectLimit";
import { useTranslation } from "react-i18next";
import useProjectLimitQueryInvalidator from "./useProjectLimitQueryInvalidator";

export const useRemoveProjectLimitMutation = () => {
  const { t } = useTranslation();
  const { toast } = useToast();
  const projectId = useProjectId();
  const { query } =
    useDataTableQuery<SuccessFetchListResponse<ReadProjectLimit>>();
  const projectLimitQueryInvalidator = useProjectLimitQueryInvalidator();

  return useMutationWithErrorHandling<unknown, ApiError, string, unknown>({
    mutationFn: (limitId: string) =>
      ProjectLimitService.delete(projectId, limitId),
    onSuccess: () => {
      toast({
        title: t("projectLimits.success.delete"),
      });
      projectLimitQueryInvalidator.invalidateAll();
      query.refetch();
    },
    errorTitle: t("projectLimits.errors.delete"),
  });
};
